<template>
  <div class="protocols_count">
    <Loadind v-if="protocolsCount === null" class="accents" />
    <div class="table" v-else>
      <div class="row top">
        <strong></strong>
        <strong>Все</strong>
        <strong>44</strong>
        <strong>223</strong>
        <strong>615</strong>
      </div>
      <div class="row">
        <p class="cap">Вчера:</p>
        <p>{{ protocolsCount.allYesterday }}</p>
        <p>{{ protocolsCount.yesterday44 }}</p>
        <p>{{ protocolsCount.yesterday223 }}</p>
        <p>{{ protocolsCount.yesterday615 }}</p>
      </div>
      <div class="row">
        <p class="cap">Сегодня:</p>
        <p>{{ protocolsCount.allToday }}</p>
        <p>{{ protocolsCount.today44 }}</p>
        <p>{{ protocolsCount.today223 }}</p>
        <p>{{ protocolsCount.today615 }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Loadind from "./loading.vue";
export default {
  name: "protocols_count",
  components: {
    Loadind,
  },
  data: () => ({
    protocolsCount: null,
  }),
  methods: {
    async getData() {
      const data = await this.$store.dispatch("PROTOCOLS_COUNT");
      this.protocolsCount = data;
    },
  },
  async created() {
    await this.getData();
  },
};
</script>
<style lang="sass" scoped>
.table
    display: grid
    .row
        display: grid
        grid-template-columns: repeat(5,1fr)
        height: 1em
        .cap
            padding: 0 5px
            font-size: 1em

</style>
